/**
 * ScrollIt
 * ScrollIt.js(scroll•it•dot•js) makes it easy to make long, vertically scrolling pages.
 *
 * Latest version: https://github.com/cmpolis/scrollIt.js
 *
 * License <https://github.com/cmpolis/scrollIt.js/blob/master/LICENSE.txt>
 */
(function($) {
	'use strict';

	var pluginName = 'ScrollIt',
		pluginVersion = '1.0.3';

	/*
	 * OPTIONS
	 */
	var defaults = {
		upKey: 38,
		downKey: 40,
		easing: 'linear',
		scrollTime: 600,
		activeClass: 'active',
		onPageChange: null,
		topOffset : 0
	};

	$.scrollIt = function(options) {

		/*
		 * DECLARATIONS
		 */
		var settings = $.extend(defaults, options),
			active = 0,
			lastIndex = $('[data-scroll-index]:last').attr('data-scroll-index');

		/*
		 * METHODS
		 */

		/**
		 * navigate
		 *
		 * sets up navigation animation
		 */
		var navigate = function(ndx) {
			if(ndx < 0 || ndx > lastIndex) return;

			var targetTop = $('[data-scroll-index=' + ndx + ']').offset().top + settings.topOffset + 1;
			$('html,body').animate({
				scrollTop: targetTop,
				easing: settings.easing
			}, settings.scrollTime);
		};

		/**
		 * doScroll
		 *
		 * runs navigation() when criteria are met
		 */
		var doScroll = function (e) {
			var target = $(e.target).closest("[data-scroll-nav]").attr('data-scroll-nav') ||
			$(e.target).closest("[data-scroll-goto]").attr('data-scroll-goto');
			navigate(parseInt(target));
		};

		/**
		 * keyNavigation
		 *
		 * sets up keyboard navigation behavior
		 */
		var keyNavigation = function (e) {
			var key = e.which;
			if($('html,body').is(':animated') && (key == settings.upKey || key == settings.downKey)) {
				return false;
			}
			if(key == settings.upKey && active > 0) {
				navigate(parseInt(active) - 1);
				return false;
			} else if(key == settings.downKey && active < lastIndex) {
				navigate(parseInt(active) + 1);
				return false;
			}
			return true;
		};

		/**
		 * updateActive
		 *
		 * sets the currently active item
		 */
		var updateActive = function(ndx) {
			if(settings.onPageChange && ndx && (active != ndx)) settings.onPageChange(ndx);

			active = ndx;
			$('[data-scroll-nav]').removeClass(settings.activeClass);
			$('[data-scroll-nav=' + ndx + ']').addClass(settings.activeClass);
		};

		/**
		 * watchActive
		 *
		 * watches currently active item and updates accordingly
		 */
		var watchActive = function() {
			var winTop = $(window).scrollTop();

			var visible = $('[data-scroll-index]').filter(function(ndx, div) {
				return winTop >= $(div).offset().top + settings.topOffset &&
				winTop < $(div).offset().top + (settings.topOffset) + $(div).outerHeight()
			});
			var newActive = visible.first().attr('data-scroll-index');
			updateActive(newActive);
		};

		/*
		 * runs methods
		 */
		$(window).on('scroll',watchActive).scroll();

		$(window).on('keydown', keyNavigation);

		$('body').on('click','[data-scroll-nav], [data-scroll-goto]', function(e){
			e.preventDefault();
			doScroll(e);
		});

	};
}(jQuery));

(function($) {
  'use strict';

  $('.js-featured-posts-slider').on('init', function(event, slick){
	var videos = jQuery(".js-featured-posts-slider video.js-video-component");
	if(videos.length){
	  videos.each(function(index, elem){
		elem.play();
	  });
	}
  });

  $('.js-featured-posts-slider').slick({
	arrows: false,
	dots: true,
	autoplay: true,
	autoplaySpeed: 5000,
	customPaging: function(slider, i) {
	  var title = $(slider.$slides[i]).find('.js-hero-panel-title').text().trim();

	  return '<button class="slider__dot-button"\
		title="' + title +'">\
		<span class="slider__dot">'+i+'</span>\
	  </button>';
	}
  });
  
 
  

  
  jQuery('.video-inline').on('click', function() {
	  
		var url = jQuery(this).data('embed');  
		  jQuery(this).html('<div class="widescreen flex-video"><iframe src="'+url+'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>');
  
	  });
	  
  
  // image comparison

    $('.hero-panel__text-container').each(function () {
		var $slide = $(this).parent();
		if ($slide.attr('aria-describedby') != undefined) { // ignore extra/cloned slides
			$(this).attr('id', $slide.attr('aria-describedby'));
		}
	});
	
	
	
	$(document).on('click', '.js-toggle-navbar-collapsed-menu', function(){
		var target = $(this).data('target');
		if($(this).hasClass('chapter-toggle')) {
			$('body').toggleClass('chapters-open');
		}
		$(this).toggleClass('has-expanded');
		$(this).parent().toggleClass('has-expanded');
		$(target).toggleClass('is-expanded');
	
		return false;
	  });
	  
	 
	
	jQuery('.collapsed-menu .chapter-links a').on('click', function(e) {
		jQuery('.navigation-bar__right .navigation-bar__menu-button').click();
	});
	
	// focus search input
	$(document).on('click', '.top-bar a.search-icon', function(e){
		var search_field = jQuery('#dropdown-search .search-field');
		if(search_field.length) {
			search_field.focus();
		}
	});
	  
	  
	// scroll it
	
	$.scrollIt({
	  upKey: 38,             // key code to navigate to the next section
	  downKey: 40,           // key code to navigate to the previous section
	  easing: 'linear',      // the easing function for animation
	  scrollTime: 600,       // how long (in ms) the animation takes
	  activeClass: 'active', // class given to the active nav element
	  onPageChange: function(pageIndex) { 
		  var title = jQuery('.chapter[data-scroll-index="'+pageIndex+'"]').data('chapter');
		  jQuery('h4.chapter-title, .post.longform-post .page-content__menu-text').text(title);
		  jQuery('.js-close-menu').click();
		  if(history.pushState) {
				history.pushState(null, null, '#chapter-'+pageIndex);
				
			}
			else {
				 window.location.hash = '#chapter-'+pageIndex;
			}
		 
		  
	  },    
	  topOffset: -75           // offste (in px) for fixed top navigation
	});
	
	
	$('.image-banner').each(function () {
		var $this = $(this);
		var image_src = $this.find('.image img').attr('src');
		
		getImageLightness(image_src,function(brightness) {
			if(brightness > 200) {
				$this.find('.image').addClass('dark-gradient');
			} else if(brightness > 150) {
				$this.find('.image').addClass('medium-gradient');
			} else if(brightness > 100) {
				$this.find('.image').addClass('light-gradient');
			}
		});
	});
	
	var textarea = document.querySelector('.wpcf7-textarea');
	if(textarea) {
		textarea.addEventListener('keydown', autosize);
	}
	
	
	function autosize(){
	  var el = this;
	  setTimeout(function(){
		el.style.cssText = 'height:auto;';
		// for box-sizing other than "content-box" use:
		// el.style.cssText = '-moz-box-sizing:content-box';
		el.style.cssText = 'height:' + el.scrollHeight + 'px';
	  },0);
	}
	
	document.addEventListener( 'wpcf7submit', function( event ) {
		  var form = jQuery('.wpcf7');
		  form[0].scrollIntoView({behavior: 'smooth'});
		}, false );
	
	
    jQuery(document).on('down.zf.accordion', function(event, element) {
		var item = jQuery(element).closest('.accordion-item');
		item[0].scrollIntoView({behavior: 'smooth'});
	});
	
	jQuery(document).on('show.zf.dropdown', function(event, element) {
	   var maxHeight = -1;
		
	
	   jQuery(element).find('.submenu-wrapper ul.menu-depth-1 ul.sub-menu').each(function() {
		 maxHeight = jQuery(element).find('.submenu-wrapper ul.menu-depth-1').height();
		 if(jQuery(this).height() < maxHeight) {
			 jQuery(this).height(maxHeight + .5);
		 } else {
			 var difference = (jQuery(this).height() - maxHeight);
			 jQuery(element).find('.submenu-wrapper ul.menu-depth-1').css('marginBottom', difference);
		 }
		 
	   });

	   var search_field = jQuery(element).find('.search-field');
	   if(search_field.length) {
		   search_field.focus();
	   }
	   
	   if(jQuery('body').hasClass('blue-header')) {
		   jQuery('body').removeClass('blue-header');
		   jQuery('body').addClass('change-white');
	   }
	});
	
	jQuery(document).on('hide.zf.dropdown', function(event, element) {
		if(jQuery('body').hasClass('change-white') && !jQuery('.top-bar').hasClass('is-stuck')) {
		   jQuery('body').addClass('blue-header');
		}
	});
	
	jQuery('.top-bar').on('sticky.zf.stuckto:top', function(event, element) {
	
		if(jQuery('body').hasClass('blue-header')) {
			jQuery('body').removeClass('blue-header');
			jQuery('body').addClass('change-white sticky-header');
		}
	});
	jQuery('.top-bar').on('sticky.zf.unstuckfrom:top', function(event, element) {
		if(jQuery('body').hasClass('change-white')) {
			jQuery('body').addClass('blue-header');
			jQuery('body').removeClass('sticky-header');
		}
	});
	
	
	
	$('.sitemap__pages a[href="#"]').each(function () {
		$(this).replaceWith($(this).text());
	});

	// Protected content - forgot password text
	if ($('.cst-forgot-password').length) {
		var $forgotPassword = $(".cst-forgot-password"),
			$toggleForgotPassword = $(".cst-toggle-forgot-password");
		$($forgotPassword).click(function() {
			$($toggleForgotPassword).slideToggle(300);
		});
    }
	   
}(jQuery));

jQuery(document).ready(function($) {
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('.accordion-title')
  .not('.js-tab-title')
  .click(function(event) {
	// On-page links
	
	if (
	  location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	  && 
	  location.hostname == this.hostname
	) {
	  // Figure out element to scroll to
	  var target = $(this.hash);
	  target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	  // Does a scroll target exist?
	  if (target.length) {
		// Only prevent default if animation is actually gonna happen
		event.preventDefault();
		target[0].scrollIntoView({behavior: 'smooth'});
	  }
	}
  });
  $('.header .menu a[href="#"]').click(function(e) {
	  e.preventDefault();
  });
});

(function($) {
	'use strict';
  var winHeight = $(window).height(), 
	  docHeight = $(document).height(),
	  progressBar = $('progress.longform-progress'),
	  max, value;

  /* Set the max scrollable area */ 
  max = docHeight - winHeight;
  progressBar.attr('max', max);

  $(document).on('scroll', function(){
	 value = $(window).scrollTop();
	 progressBar.attr('value', value);
  });
  
}(jQuery));

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// object-fit polyfill
if ('objectFit' in document.documentElement.style === false) {
	document.addEventListener('DOMContentLoaded', function() {
		document.querySelectorAll('img[data-object-fit]').forEach(function(image) {
			(image.runtimeStyle || image.style).background = "url(\"".concat(image.src, "\") no-repeat 50%/").concat(image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit'));
			image.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(image.width, "' height='").concat(image.height, "'%3E%3C/svg%3E");
		});
	});
}